import { render, staticRenderFns } from "./ReportDetailsList.vue?vue&type=template&id=dc0c4a68&scoped=true&"
import script from "./ReportDetailsList.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailsList.vue?vue&type=style&index=0&id=dc0c4a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c4a68",
  null
  
)

export default component.exports